export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@ñ"]+(\.[^<>()[\]\\.,;:\s@ñ"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const TEXT_REGEX =
  /^[a-zA-ZñÑáéíóúÁÉÍÓÚçÇàèìòùÀÈÌÒÙäÄëËïÏöÖüÜâêîôûÂÊÎÔÛãõÃÕ\s'ªº.-]+$/;
export const ADDRESS_REGEX =
  /^[A-Za-z0-9/ªºñÑáéíóúÁÉÍÓÚçÇàèìòùÀÈÌÒÙüÜ\s,'´`;:·-]+$/;
export const DNI_REGEX = /^(\d{8})([A-Za-z])$/;
export const NIE_REGEX = /^[xyzXYZ]\d{7,8}[A-Za-z]$/;
export const CIF_REGEX =
  /^([ABCDEFGHJKLMNPQRSUVWabcdefghjklmnpqrsuvw])(\d{7})([0-9A-Ja-j])$/;
export const PASSPORT_REGEX = /^[A-Za-z0-9]+$/;
export const DOC_NUMBER_REGEX = /^[xyzXYZ]?([0-9]{7,8})([A-Za-z])$/;
export const MOBILE_PHONE_REGEX = /^[67]\d{8}$/;
export const LAND_PHONE_REGEX = /^[8|9][0-9]{8}$/;
export const POSTAL_CODE_REGEX = /^\d{5}$/;
export const RE_DIGIT = /^\d+$/;
export const CONTACT_MEDIA_REGEX =
  /(^[67]\d{8}$)|(^(([^<>()[\]\\.,;:\s@ñ"]+(\.[^<>()[\]\\.,;:\s@ñ"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

export const validateIban = (value) => {
  // Eliminar los espacios en blanco y convertir a mayúsculas
  const bankAccount = value.replace(/\s+/g, '').toUpperCase();

  // Verificar el formato del IBAN
  if (!/^ES\d{22}$/.test(bankAccount)) {
    return false; // Formato incorrecto
  }

  // Obtener los dígitos de control del IBAN
  const digitosControl = bankAccount.substring(2, 4);

  // Reemplazar las letras por números
  const numeroCuenta = bankAccount.substring(4);
  const numeroCompleto = `${numeroCuenta}142800`;

  // Calcular el resto de la división por 97
  const numero = BigInt(numeroCompleto);
  const resto = numero % BigInt(97);
  const digitoControlCalculado = (BigInt(98) - resto)
    .toString()
    .padStart(2, '0');

  // Verificar si el dígito de control del IBAN coincide
  return digitoControlCalculado === digitosControl;
};

export const validateMobilePhone = (value) => {
  const phoneWithoutSpaces = value.replace(/\s/g, '');
  let validated = true;
  validated = MOBILE_PHONE_REGEX.test(phoneWithoutSpaces);
  return validated;
};
export const validateLandLinePhone = (value) => {
  const phoneWithoutSpaces = value.replace(/\s/g, '');
  let validated = true;
  validated = LAND_PHONE_REGEX.test(phoneWithoutSpaces);
  return validated;
};
export const validDNI = (docNumber) => {
  const upperCaseDocNumber = docNumber.toUpperCase();
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const letter = dniLetters.charAt(parseInt(upperCaseDocNumber, 10) % 23);
  return letter === upperCaseDocNumber.charAt(8);
};

export const validNIE = (docNumber) => {
  const upperCaseDocNumber = docNumber.toUpperCase();
  // Change the initial letter for the corresponding number and validate as DNI
  let niePrefix = upperCaseDocNumber.charAt(0);

  switch (niePrefix) {
    case 'X':
      niePrefix = 0;
      break;
    case 'Y':
      niePrefix = 1;
      break;
    case 'Z':
      niePrefix = 2;
      break;
    default:
  }
  return validDNI(niePrefix + upperCaseDocNumber.substr(1));
};
export const getDocNumberType = (docNumber) => {
  let docType = '';
  if (docNumber.match(DNI_REGEX) && validDNI(docNumber)) {
    docType = 'DNI';
  } else if (docNumber.match(NIE_REGEX) && validNIE(docNumber)) {
    docType = 'NIE';
  }
  return docType;
};

export const validDocNumber = (docNumber) => {
  return (
    DNI_REGEX.test(docNumber) ||
    CIF_REGEX.test(docNumber) ||
    NIE_REGEX.test(docNumber) ||
    PASSPORT_REGEX.test(docNumber)
  );
};

export const customValidEmail = (email) => {
  const domain = email.slice(-4);
  const domainsNotAllowed = ['.con'];
  const isDomainNotAllowed = domainsNotAllowed.includes(domain);
  return !isDomainNotAllowed;
};
export const validContactMedia = (contactMedia) => {
  if (EMAIL_REGEX.test(contactMedia)) {
    const domain = contactMedia.slice(-4);
    const domainsNotAllowed = ['.con'];
    const isDomainNotAllowed = domainsNotAllowed.includes(domain);
    return !isDomainNotAllowed;
  }
  return MOBILE_PHONE_REGEX.test(contactMedia);
};
export const validPrevContactMedia = (contactMedia, oldContactMedia) => {
  return oldContactMedia !== contactMedia;
};

export const validEmptyText = (text) => {
  let textAux = '';
  if (text) {
    textAux = text.trim();
  }
  return textAux.length > 0;
};
export const validSearchInput = (data) => {
  const { value } = { ...data };
  return !!value;
};
